var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconProfileDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4A606A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4 12.821c2.85 0 5.161-2.216 5.161-4.95 0-2.733-2.31-4.949-5.16-4.949s-5.16 2.216-5.16 4.95c0 2.733 2.31 4.95 5.16 4.95zm0 2.475c-4.274 0-7.74-3.324-7.74-7.424 0-4.1 3.466-7.424 7.74-7.424 4.276 0 7.741 3.324 7.741 7.424 0 4.1-3.465 7.424-7.74 7.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.721 25.195c0-5.467-4.62-9.9-10.32-9.9s-10.32 4.433-10.32 9.9m-2.581 0C.5 18.36 6.276 12.82 13.4 12.82c7.126 0 12.901 5.54 12.901 12.374"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconProfileDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-profile-default.59173271851e841d05890c0cbd5d1838.svg";